import React, { createContext, useContext, useState } from "react";
import splitFilesIntoChunks from "utilities/splitIntoChunks";

const FileUploadContext = createContext<any | null>(null);

export const FileUploadProvider = ({ children }: any) => {
  const [showUploader, setShowUploader] = useState(false);
  const [fileDetails, setFileDetails] = useState<any>(null);
  const [fileLoading, setFileLoading] = useState(false);
  const [totalUpload, setTotalUpload] = useState(0);
  const [filesUploaded, setFilesUploaded] = useState(0);
  const [totalFilesAmount, setTotalFilesAmount] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [filesWithErrors, setFilesWithErrors] = useState<any>([]);
  const [uploaderMessage, setUploaderMessage] = useState({ type: 'none', message: '' });

  const handleFile = (filesUploaded: any) => {
    if (!filesUploaded && !fileDetails?.fileName) {
      setFileDetails(null);
    } else if (filesUploaded) {
      setTotalFilesAmount(filesUploaded.length);
      setFileDetails(splitFilesIntoChunks(filesUploaded, 2)); // Assuming stepsCount is 2
    }
  };

  const handleFileSubmit = async (fileUploaderApiConfig: any) => {
    setFilesUploaded(0);
    setFileLoading(true);
    setShowProgressBar(true);
    try {
      let filesUploadedSoFar = 0;
      for (const fileBundle of fileDetails) {
        const processedFiles = Object.values(fileBundle);
        const fileNames = processedFiles.map((file: any) => file.name);
        const formData = new FormData();
        processedFiles.forEach((file: any) => formData.append('file', file));

        try {
          const response = await fileUploaderApiConfig.uploadImagesForPointClouds(formData);
          if (response.status === 200) {
            filesUploadedSoFar += processedFiles.length;
            const newProgress = (filesUploadedSoFar / totalFilesAmount) * 100;
            setFilesUploaded(filesUploadedSoFar);
            setTotalUpload(newProgress);
          } else {
            throw new Error("Upload failed");
          }
        } catch (error) {
          setFilesWithErrors((prev: any) => [...prev, ...fileNames]);
        }
      }
    } catch (error) {
      setShowProgressBar(false);
    } finally {
      setFileLoading(false);
    }
  };

  return (
    <FileUploadContext.Provider value={{
      fileDetails, fileLoading, totalUpload, filesUploaded, totalFilesAmount, showProgressBar, filesWithErrors,
      handleFile, handleFileSubmit, setFileDetails, showUploader, setShowUploader, uploaderMessage, setUploaderMessage, setFileLoading, setTotalUpload, setFilesUploaded, setTotalFilesAmount, setShowProgressBar, setFilesWithErrors
    }}>
      {children}
    </FileUploadContext.Provider>
  );
};

export const useFileUpload = () => useContext(FileUploadContext);